import Article from 'Pages/article/home'

export default Article
